import React, { useState, useRef, useEffect } from 'react';
import styles from './QuizCheckbox.module.scss';
import classNames from 'classnames';
import CheckboxChecked from '../../../assets/icons/checkbox-checked.svg';
import CheckboxUnchecked from '../../../assets/icons/checkbxo-unchecked.svg';
import TypingEffect from '../../ui/TypingEffect/TypingEffect';

interface QuizCheckboxProps {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const QuizCheckbox: React.FC<QuizCheckboxProps> = ({
  checked,
  label,
  onChange,
  disabled = false,
}) => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const initialCheckedRef = useRef(checked);

  // If it was already checked on mount, skip animation
  useEffect(() => {
    if (initialCheckedRef.current) {
      setHasAnimated(true);
    }
  }, []);

  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleTypingComplete = () => {
    setHasAnimated(true);
  };

  return (
    <div
      className={classNames(styles.quizCheckbox, {
        [styles.checked]: checked,
        [styles.disabled]: disabled,
      })}
      onClick={handleClick}
    >
      <img
        src={checked ? CheckboxChecked : CheckboxUnchecked}
        alt={checked ? 'Checked' : 'Unchecked'}
        className={styles.checkboxIcon}
      />
      <span className={styles.label}>
        {hasAnimated ? label : <TypingEffect text={label} speed={15} onComplete={handleTypingComplete} />}
      </span>
    </div>
  );
};

export default QuizCheckbox;
